export default __webpack_public_path__ + "static/media/app-logo.d6de5249.svg";